module.exports = __webpack_public_path__ + "img/secure.988db075.svg";